import * as React from "react";
import {Button, Typography} from "@mui/material";
import {useTranslation} from "react-i18next";
import {api} from "../../../../api/api";
import {useSelector} from "react-redux";

import DownloadButton from "../../../../components/Icons/DownloadButton";
import {RootState} from "../../../../store/store";
import theme from "../../../../components/styles/theme/theme";
import usePrintToPdf from "../../../../utils/usePrintToPdf";
import {isPDFGenerationEnabled, isRegion} from "../../../../config";

interface DownloadButtonsProps {
    printRef: React.RefObject<HTMLElement>;
}

export const DownloadButtons: React.FC<DownloadButtonsProps> = ({printRef}) => {
    const {t} = useTranslation();
    const {
        map: {year, selectedCountry, defaultCountry, selectedState, selectedDistrict},
    } = useSelector((state: RootState) => state);

    const {generatePDFs, inProgress} = usePrintToPdf(printRef);


    return defaultCountry ? (
        <>
            <Button
                className="hidden-print"
                onClick={
                    async () => {
                        isPDFGenerationEnabled ? await generatePDFs() :
                            api.getInfographic(
                                year,
                                selectedCountry?.iso3 || defaultCountry.iso3,
                                selectedState?.state_id,
                                selectedDistrict
                            )

                    }
                }
                size="small"
                disabled={!year || inProgress}
                sx={{
                    padding: "8px 16px",
                    marginTop: "10px",
                    backgroundColor: "primary.800",
                    ":hover": {
                        backgroundColor: "custom.purple",
                    },
                    ":disabled": {
                        backgroundColor: theme.palette.text.disabled,
                    },
                }}
            >
                <Typography
                    paddingRight="10px"
                    component="span"
                    variant="body2"
                    color={theme.palette.common.white}
                    sx={{textTransform: "none"}}
                >
                    {isPDFGenerationEnabled ? "Generate PDFs" : t("common.download_infographic")}
                </Typography>
                <DownloadButton
                    color={theme.palette.common.white}
                    width="12px"
                    height="15px"
                />
            </Button>
            {!isRegion.usa && (
                <Button
                    className="hidden-print"
                    onClick={() =>
                        api.getReport(year, selectedCountry?.iso3 || defaultCountry.iso3)
                    }
                    sx={{
                        padding: "8px 16px",
                        marginTop: "10px",
                        backgroundColor: "secondary.main",
                        ":hover": {
                            backgroundColor: "secondary.dark",
                        },
                        ":disabled": {
                            backgroundColor: theme.palette.secondary["200"],
                        },
                    }}
                    size="small"
                    disabled={!year}
                >
                    <Typography
                        paddingRight="10px"
                        component="span"
                        variant="body2"
                        color={theme.palette.common.white}
                        sx={{
                            textTransform: "none",
                        }}
                    >
                        {t("common.download_full_report")}
                    </Typography>
                    <DownloadButton
                        color={theme.palette.common.white}
                        width="12px"
                        height="15px"
                    />
                </Button>
            )}
        </>
    ) : null;
};
